/* Black Friday 2026 stack builder.
   Only used by sections/bf-2026-stack.liquid.
   Delete this file with the section, stylesheet, and page template when the sale ends. */
(function () {
  'use strict';

  var MAX_QTY = 20;
  var STORAGE_KEY = 'bf26-stack-v1';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function shopifyRoot() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.charAt(root.length - 1) === '/' ? root : root + '/';
  }

  function formatWithDelimiters(cents, precision, thousands, decimal) {
    var number = (cents / 100).toFixed(precision);
    var parts = number.split('.');
    var dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
    return parts[1] ? dollars + decimal + parts[1] : dollars;
  }

  function formatMoney(cents, format) {
    var amount = Math.round(Number(cents) || 0);
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var token = (String(format || '${{amount}}').match(placeholder) || [])[1];
    var value;
    switch (token) {
      case 'amount_no_decimals':
        value = formatWithDelimiters(amount, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(amount, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(amount, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(amount, 2, "'", '.');
        break;
      default:
        value = formatWithDelimiters(amount, 2, ',', '.');
    }
    var formatted = String(format || '${{amount}}').replace(placeholder, value);
    if (amount % 100 === 0) formatted = formatted.replace(/[.,]00(?=\s|$)/, '');
    return formatted;
  }

  function planDays(plan) {
    var options = (plan && plan.options) || [];
    var i;
    for (i = 0; i < options.length; i++) {
      var value = String(options[i].value || '').toLowerCase().trim();
      var exact = value.match(/^(\d+)\s*-?\s*days?$/);
      if (exact) return parseInt(exact[1], 10);
    }
    var named = String((plan && plan.name) || '').toLowerCase().match(/(\d+)\s*-?\s*days?/);
    return named ? parseInt(named[1], 10) : null;
  }

  function planForDays(plans, days) {
    var match = null;
    (plans || []).some(function (plan) {
      if (planDays(plan) === days) {
        match = plan;
        return true;
      }
      return false;
    });
    return match;
  }

  function moneyText(config, cents) {
    var format = String(config.moneyFormat || '${{amount}}').replace(/\s*AUD\b/gi, '').trim();
    if (format.indexOf('$') === -1) format = '$' + format;
    return formatMoney(cents, format).replace(/\s*AUD\b/gi, '').replace(/\$\$/g, '$').trim();
  }

  function miniWord(count) {
    return count === 1 ? '1 mini' : count + ' minis';
  }

  function giftImageFor(count) {
    if (count === 1) return 'https://cdn.shopify.com/s/files/1/0730/6949/4491/files/FSFBF-0.png?v=1791853953';
    if (count === 2) return 'https://cdn.shopify.com/s/files/1/0730/6949/4491/files/FSFBF-1.png?v=1791853953';
    if (count === 4) return 'https://cdn.shopify.com/s/files/1/0730/6949/4491/files/FSFBF-2.png?v=1791853954';
    return '';
  }

  function init(root) {
    if (root.getAttribute('data-bf26-ready') === 'true') return;
    var configNode = root.querySelector('[data-bf26-config]');
    if (!configNode) return;
    var config;
    try {
      config = JSON.parse(configNode.textContent);
    } catch (error) {
      return;
    }
    root.setAttribute('data-bf26-ready', 'true');
    root.querySelectorAll('.bf26-cart-note, [data-bf-cart-note]').forEach(function (node) {
      node.remove();
    });

    var tiers = (config.thresholds || []).slice().sort(function (a, b) {
      return a.spend - b.spend;
    });
    var products = config.products || [];
    var PAGE_SIZE = 9;
    var visibleCount = PAGE_SIZE;
    var searchQuery = '';
    var catalog = [];
    products.forEach(function (product) {
      product.plansLoaded = !!(product.plans && product.plans.length);
    });
    var minis = config.minis || [];
    var intervals = config.intervals || [30, 60, 90];
    var maxCents = tiers.length ? tiers[tiers.length - 1].spend : 50000;
    if (!maxCents) maxCents = 50000;

    var tierSeen = {};
    var tiersReady = false;
    var cards = {};
    root.querySelectorAll('[data-bf-card]').forEach(function (card) {
      cards[card.getAttribute('data-handle')] = card;
    });
    var miniRows = {};
    root.querySelectorAll('[data-bf-mini]').forEach(function (row) {
      miniRows[row.getAttribute('data-handle')] = row;
    });

    var savedQty = {};
    var state = {
      days: Number(config.defaultDays) || 90,
      qty: {},
      minis: {},
      flash: '',
      busy: false,
      error: '',
      hasStack: false
    };
    var pendingQty = {};

    if (intervals.indexOf(state.days) === -1) state.days = intervals[0] || 90;

    try {
      var saved = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || 'null');
      if (saved && typeof saved === 'object') {
        if (intervals.indexOf(Number(saved.days)) !== -1) state.days = Number(saved.days);
        savedQty = saved.qty || {};
        products.forEach(function (product) {
          var qty = parseInt(savedQty[product.handle], 10);
          if (product.available && qty > 0) state.qty[product.handle] = Math.min(qty, MAX_QTY);
        });
        minis.forEach(function (mini) {
          var qty = parseInt(saved.minis && saved.minis[mini.handle], 10);
          if (mini.available && qty > 0) state.minis[mini.handle] = qty;
        });
      }
    } catch (error) {
      /* keep the empty stack */
    }

    function payable(cents) {
      // 25% off the catalogue price. Was 0.8 while the offer was 20% off forever.
      return Math.round(Number(cents) * 0.75);
    }

    function subtotal() {
      return products.reduce(function (sum, product) {
        return sum + payable(product.price) * (state.qty[product.handle] || 0);
      }, 0);
    }

    function catalogueTotal() {
      return products.reduce(function (sum, product) {
        return sum + product.price * (state.qty[product.handle] || 0);
      }, 0);
    }

    function fillPrice(node, originalCents, saleCents) {
      node.replaceChildren();
      if (originalCents > saleCents) {
        var was = document.createElement('s');
        was.className = 'bf26-was';
        was.textContent = moneyText(config, originalCents);
        node.appendChild(was);
      }
      var now = document.createElement('span');
      now.className = 'bf26-now';
      now.textContent = moneyText(config, saleCents);
      node.appendChild(now);
    }

    function currentTier(cents) {
      var found = null;
      tiers.forEach(function (tier) {
        if (cents >= tier.spend) found = tier;
      });
      return found;
    }

    function slotsFor(cents) {
      var tier = currentTier(cents);
      return tier ? tier.minis : 0;
    }

    function miniCount() {
      return minis.reduce(function (sum, mini) {
        return sum + (state.minis[mini.handle] || 0);
      }, 0);
    }

    function trimMinis(slots) {
      if (slots < 1) return false;
      var total = miniCount();
      if (total <= slots) return false;
      for (var i = minis.length - 1; i >= 0 && total > slots; i--) {
        var handle = minis[i].handle;
        var qty = state.minis[handle] || 0;
        if (!qty) continue;
        var cut = Math.min(qty, total - slots);
        state.minis[handle] = qty - cut;
        if (!state.minis[handle]) delete state.minis[handle];
        total -= cut;
      }
      return true;
    }

    function selectedProducts() {
      return products.filter(function (product) {
        return (state.qty[product.handle] || 0) > 0;
      });
    }

    function missingPlan() {
      var missing = null;
      selectedProducts().some(function (product) {
        if (!product.plansLoaded) return false;
        if (!planForDays(product.plans, state.days)) {
          missing = product;
          return true;
        }
        return false;
      });
      return missing;
    }

    function ensurePlans(product) {
      if (!product || product.plansLoaded) return Promise.resolve(product);
      return fetch(shopifyRoot() + 'products/' + product.handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (response) { return response.json(); })
        .then(function (data) {
          product.plans = [];
          (data.selling_plan_groups || []).forEach(function (group) {
            (group.selling_plans || []).forEach(function (plan) {
              product.plans.push({
                id: plan.id,
                name: plan.name || '',
                options: plan.options || []
              });
            });
          });
          if (data.variants && data.variants[0]) {
            product.variantId = data.variants[0].id;
            product.price = data.variants[0].price;
            product.available = !!data.variants[0].available;
          }
          product.plansLoaded = true;
          return product;
        });
    }

    function stackMessage(cents) {
      if (state.error) return state.error;
      if (!selectedProducts().length) return 'Choose a product to start your stack.';
      var missing = missingPlan();
      if (missing) return missing.title + ' has no ' + state.days + ' day delivery plan.';
      return '';
    }

    function checkoutMessage(cents) {
      var base = stackMessage(cents);
      if (base) return base;
      /* PAUSED Oct 2026 — client removed the free-mini requirement.
         Restore this block together with the mini modal in sections/bf-2026-stack.liquid.
      var slots = slotsFor(cents);
      var chosen = miniCount();
      if (slots > 0 && chosen < slots) {
        var left = slots - chosen;
        return left === 1 ? 'Choose 1 more mini.' : 'Choose ' + left + ' more minis.';
      }
      */
      return '';
    }

    function canCheckout(cents) {
      return !state.busy && !checkoutMessage(cents);
    }

    function persist() {
      try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
          days: state.days,
          qty: state.qty,
          minis: state.minis
        }));
      } catch (error) {
        /* storage can be blocked; the page still works */
      }
    }

    function setText(selector, text) {
      root.querySelectorAll(selector).forEach(function (node) {
        node.textContent = text;
      });
    }

    function render() {
      var cents = subtotal();
      var slots = slotsFor(cents);
      if (trimMinis(slots)) {
        state.flash = 'Your mini picks were updated to match this tier.';
      }
      var chosen = miniCount();
      var tier = currentTier(cents);
      var next = null;
      tiers.some(function (item) {
        if (cents < item.spend) {
          next = item;
          return true;
        }
        return false;
      });

      root.querySelectorAll('[data-bf-days]').forEach(function (button) {
        var on = Number(button.getAttribute('data-bf-days')) === state.days;
        button.setAttribute('aria-checked', on ? 'true' : 'false');
      });

      products.forEach(function (product) {
        var card = cards[product.handle];
        if (!card) return;
        var inStack = (state.qty[product.handle] || 0) > 0;
        var qty = shownQty(product.handle);
        var plan = planForDays(product.plans, state.days);
        card.classList.toggle('is-in', inStack);
        var priceNode = card.querySelector('[data-bf-price]');
        if (priceNode) fillPrice(priceNode, product.price, payable(product.price));
        var qtyNode = card.querySelector('[data-bf-qty]');
        if (qtyNode) qtyNode.textContent = String(qty);
        var add = card.querySelector('[data-bf-add]');
        var addButton = card.querySelector('[data-bf-add-one]');
        var stepper = card.querySelector('[data-bf-stepper]');
        var dec = card.querySelector('[data-bf-dec]');
        if (add) add.hidden = !product.available;
        if (addButton) {
          addButton.textContent = inStack ? 'Added' : 'Add to my subscription';
          addButton.classList.toggle('is-added', inStack);
        }
        if (stepper) stepper.hidden = !product.available;
        if (dec) dec.disabled = qty < 1;
        var warn = card.querySelector('[data-bf-warn]');
        if (warn) {
          var showWarn = product.available && inStack && product.plansLoaded && !plan;
          warn.hidden = !showWarn;
          warn.textContent = showWarn ? 'No ' + state.days + ' day plan on this product.' : '';
        }
      });

      var lines = root.querySelector('[data-bf-lines]');
      if (lines) {
        lines.replaceChildren();
        var chosenProducts = selectedProducts();
        if (!chosenProducts.length) {
          lines.appendChild(textNode('p', 'bf26-empty', 'Your stack is empty. Choose a product to begin.'));
        } else {
          chosenProducts.forEach(function (product) {
            var qty = state.qty[product.handle];
            var row = document.createElement('div');
            row.className = 'bf26-line';
            if (product.image) {
              var image = document.createElement('img');
              image.src = product.image;
              image.alt = '';
              image.width = 44;
              image.height = 44;
              row.appendChild(image);
            }
            var copy = document.createElement('div');
            copy.appendChild(textNode('p', 'bf26-line__name', product.title + ' × ' + qty));
            var remove = document.createElement('button');
            remove.type = 'button';
            remove.className = 'bf26-line__remove';
            remove.setAttribute('data-bf-remove', product.handle);
            remove.textContent = 'Remove';
            copy.appendChild(remove);
            row.appendChild(copy);
            var linePrice = document.createElement('p');
            linePrice.className = 'bf26-line__price';
            fillPrice(linePrice, product.price * qty, payable(product.price) * qty);
            row.appendChild(linePrice);
            lines.appendChild(row);
          });
        }
      }

      setText('[data-bf-stack-title]', 'Your ' + state.days + ' day stack');
      setText('[data-bf-every]', 'Delivery every ' + state.days + ' days');
      var list = catalogueTotal();
      var hasItems = selectedProducts().length > 0;
      setText('[data-bf-total]', hasItems ? moneyText(config, cents) : '');
      root.querySelectorAll('[data-bf-total-wrap]').forEach(function (node) {
        node.hidden = !hasItems;
      });
      root.querySelectorAll('[data-bf-was]').forEach(function (node) {
        var showWas = list > cents;
        node.hidden = !showWas;
        node.textContent = showWas ? moneyText(config, list) : '';
      });

      var pct = Math.max(0, Math.min(100, (cents / maxCents) * 100));
      var fill = root.querySelector('[data-bf-fill]');
      var pin = root.querySelector('[data-bf-pin]');
      if (fill) fill.style.width = pct + '%';
      if (pin) {
        pin.style.left = pct + '%';
        pin.textContent = moneyText(config, cents);
        pin.classList.toggle('is-mid', pct > 12 && pct < 88);
        pin.classList.toggle('is-end', pct >= 88);
      }
      var meter = root.querySelector('[data-bf-meter]');
      if (meter) {
        meter.setAttribute('aria-valuenow', String(Math.round(cents / 100)));
        meter.setAttribute('aria-valuemax', String(Math.round(maxCents / 100)));
        meter.setAttribute('aria-valuetext', moneyText(config, cents));
      }

      var dockTier = root.querySelector('[data-bf-dock-tier]');
      var dockGift = root.querySelector('[data-bf-dock-gift]');
      var dockShown = tier || next;
      if (dockTier) {
        if (tier) dockTier.textContent = 'Your gifts: ' + miniWord(tier.minis) + ' + ' + moneyText(config, tier.card) + ' gift card';
        else if (next) dockTier.textContent = 'Next: ' + miniWord(next.minis) + ' + ' + moneyText(config, next.card) + ' gift card';
        else dockTier.textContent = 'Add products to unlock gifts';
      }
      if (dockGift) {
        var giftSrc = dockShown ? giftImageFor(dockShown.minis) : '';
        dockGift.hidden = !giftSrc;
        if (giftSrc) dockGift.src = giftSrc;
      }

      var progress = root.querySelector('[data-bf-progress]');
      if (progress) {
        if (!next && tier) {
          progress.textContent = miniWord(tier.minis) + ' + a ' + moneyText(config, tier.card) + ' gift card unlocked.';
        } else if (next) {
          var gap = Math.max(0, next.spend - cents);
          progress.textContent = 'Add ' + moneyText(config, gap) + ' to unlock ' + miniWord(next.minis) + ' + a ' + moneyText(config, next.card) + ' gift card.';
        }
      }

      root.querySelectorAll('[data-bf-tier]').forEach(function (row) {
        var spend = Number(row.getAttribute('data-spend'));
        var index = tiers.findIndex(function (item) {
          return item.spend === spend;
        });
        var reached = cents >= spend;
        var isCurrent = reached && (index === tiers.length - 1 || cents < tiers[index + 1].spend);
        if (tiersReady && reached && !tierSeen[spend]) {
          row.classList.remove('is-unlock');
          void row.offsetWidth;
          row.classList.add('is-unlock');
        }
        tierSeen[spend] = reached;
        row.classList.toggle('is-current', isCurrent);
        row.classList.toggle('is-locked', !reached);
        row.classList.toggle('is-passed', reached && !isCurrent);
      });
      tiersReady = true;
      if (slots < 1) closeMiniModal();

      setText('[data-bf-picker-title]', 'Choose your ' + miniWord(slots || 0));
      setText('[data-bf-picker-count]', slots ? chosen + ' of ' + slots + ' selected' : '');

      minis.forEach(function (mini) {
        var row = miniRows[mini.handle];
        if (!row) return;
        var qty = state.minis[mini.handle] || 0;
        var box = row.querySelector('[data-bf-mini-check]');
        if (box) {
          box.checked = qty > 0;
          box.disabled = !mini.available || (qty < 1 && chosen >= slots);
        }
        row.classList.toggle('is-off', !mini.available || (qty < 1 && chosen >= slots));
      });

      var chosenList = root.querySelector('[data-bf-chosen]');
      if (chosenList) {
        chosenList.replaceChildren();
        if (slots > 0) {
          minis.forEach(function (mini) {
            var qty = state.minis[mini.handle] || 0;
            if (qty > 0) chosenList.appendChild(textNode('p', '', mini.title + ' × ' + qty));
          });
        }
      }

      var flash = root.querySelector('[data-bf-flash]');
      if (flash) {
        flash.hidden = !state.flash;
        flash.textContent = state.flash || '';
      }

      var stackProblem = stackMessage(cents);
      var message = checkoutMessage(cents);
      var status = root.querySelector('[data-bf-status]');
      if (status) {
        status.textContent = stackProblem;
      }
      var modalStatus = root.querySelector('[data-bf-modal-status]');
      if (modalStatus) modalStatus.textContent = slots > 0 && !stackProblem ? message : '';
      var canContinue = !state.busy && !stackProblem;
      root.querySelectorAll('[data-bf-next]').forEach(function (button) {
        button.disabled = !canContinue;
        if (state.busy) button.textContent = state.hasStack ? 'Updating…' : 'Starting…';
        /* PAUSED Oct 2026 — "Select your Free Mini's" button. Restore with the mini modal.
        else if (slots > 0) button.textContent = "Select your Free Mini's";
        */
        else button.textContent = state.hasStack ? 'Update my subscription' : 'Start my subscription';
      });
      root.querySelectorAll('[data-bf-modal-checkout]').forEach(function (button) {
        button.disabled = !canCheckout(cents);
        if (state.busy) button.textContent = state.hasStack ? 'Updating…' : 'Starting…';
        else button.textContent = state.hasStack ? 'Update my subscription' : 'Start My Subscription';
      });

      persist();
    }

    function textNode(tag, className, text) {
      var node = document.createElement(tag);
      if (className) node.className = className;
      node.textContent = text;
      return node;
    }

    function shownQty(handle) {
      if (Object.prototype.hasOwnProperty.call(pendingQty, handle)) return pendingQty[handle];
      return state.qty[handle] || 1;
    }

    function commitQty(handle, qty) {
      var product = productByHandle(handle);
      if (!product || !product.available) return;
      var next = Math.max(0, Math.min(MAX_QTY, qty));
      pendingQty[handle] = next;
      if (next) state.qty[handle] = next;
      else delete state.qty[handle];
      render();
      if (next > 0) ensurePlans(product).then(render);
    }

    function changePending(handle, qty) {
      var product = productByHandle(handle);
      if (!product || !product.available) return;
      var next = Math.max(0, Math.min(MAX_QTY, qty));
      pendingQty[handle] = next;
      if (state.qty[handle]) commitQty(handle, next);
      else render();
    }

    function addToStack(handle) {
      if (state.qty[handle]) return;
      var next = shownQty(handle);
      commitQty(handle, next > 0 ? next : 1);
    }

    root.addEventListener('click', function (event) {
      var daysButton = event.target.closest('[data-bf-days]');
      if (daysButton && root.contains(daysButton)) {
        state.error = '';
        state.flash = '';
        state.days = Number(daysButton.getAttribute('data-bf-days'));
        render();
        return;
      }

      var card = event.target.closest('[data-bf-card]');
      if (card && root.contains(card)) {
        var handle = card.getAttribute('data-handle');
        if (event.target.closest('[data-bf-add-one]')) {
          state.error = '';
          state.flash = '';
          addToStack(handle);
          return;
        }
        var shortcut = event.target.closest('[data-bf-set]');
        if (shortcut) {
          state.error = '';
          state.flash = '';
          changePending(handle, Number(shortcut.getAttribute('data-bf-set')));
          return;
        }
        if (event.target.closest('[data-bf-inc]')) {
          state.error = '';
          state.flash = '';
          changePending(handle, shownQty(handle) + 1);
          return;
        }
        if (event.target.closest('[data-bf-dec]')) {
          state.error = '';
          state.flash = '';
          changePending(handle, shownQty(handle) - 1);
          return;
        }
      }

      var remove = event.target.closest('[data-bf-remove]');
      if (remove && root.contains(remove)) {
        state.error = '';
        state.flash = '';
        var removedHandle = remove.getAttribute('data-bf-remove');
        delete state.qty[removedHandle];
        delete pendingQty[removedHandle];
        render();
        return;
      }

      if (event.target.closest('[data-bf-modal-close]')) {
        closeMiniModal();
        return;
      }

      var dockToggle = event.target.closest('[data-bf-dock-toggle]');
      if (dockToggle && root.contains(dockToggle)) {
        setDockOpen(!root.querySelector('.bf26-summary').classList.contains('is-open'));
        return;
      }

      if (event.target.closest('[data-bf-next]')) {
        /* PAUSED Oct 2026 — used to open the mini picker once a gift tier was reached.
           Restore openMiniModal() with the modal in sections/bf-2026-stack.liquid.
        if (slotsFor(subtotal()) > 0) openMiniModal();
        else startCheckout();
        */
        startCheckout();
        return;
      }

      if (event.target.closest('[data-bf-modal-checkout]')) {
        startCheckout();
      }
    });

    root.addEventListener('change', function (event) {
      var box = event.target.closest('[data-bf-mini-check]');
      if (!box || !root.contains(box)) return;
      var row = box.closest('[data-bf-mini]');
      var handle = row && row.getAttribute('data-handle');
      var mini = minis.filter(function (item) { return item.handle === handle; })[0];
      if (!mini || !mini.available) {
        box.checked = false;
        return;
      }
      state.error = '';
      state.flash = '';
      if (box.checked) {
        if (miniCount() >= slotsFor(subtotal())) {
          box.checked = false;
          return;
        }
        state.minis[handle] = 1;
      } else {
        delete state.minis[handle];
      }
      render();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeMiniModal();
    });

    function setDockOpen(open) {
      var summary = root.querySelector('.bf26-summary');
      var toggle = root.querySelector('[data-bf-dock-toggle]');
      if (!summary) return;
      summary.classList.toggle('is-open', open);
      if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function openMiniModal() {
      var modal = root.querySelector('[data-bf-modal]');
      if (!modal) return;
      setDockOpen(false);
      modal.hidden = false;
      document.documentElement.classList.add('bf26-modal-open');
    }

    function closeMiniModal() {
      var modal = root.querySelector('[data-bf-modal]');
      if (!modal || modal.hidden) return;
      modal.hidden = true;
      document.documentElement.classList.remove('bf26-modal-open');
    }

    function lineProperties(item) {
      var props = item && item.properties;
      if (!props) return {};
      if (!Array.isArray(props)) return props;
      var map = {};
      props.forEach(function (entry) {
        if (entry && entry.name) map[entry.name] = entry.value;
      });
      return map;
    }

    function isStackLine(item) {
      return lineProperties(item)._bf_stack === 'Black Friday 2026';
    }

    function isMiniLine(item) {
      return lineProperties(item).Gift === 'Black Friday mini';
    }

    function linePlanId(line) {
      var allocation = line.selling_plan_allocation;
      if (!allocation || !allocation.selling_plan) return 0;
      return Number(allocation.selling_plan.id) || 0;
    }

    function takeLine(lines, variantId, used) {
      var found = null;
      lines.some(function (line) {
        if (used[line.key]) return false;
        if (Number(line.variant_id || line.id) !== Number(variantId)) return false;
        found = line;
        return true;
      });
      if (found) used[found.key] = true;
      return found;
    }

    async function getCart() {
      var response = await fetch(shopifyRoot() + 'cart.js', {
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) throw new Error('Could not read the cart.');
      return response.json();
    }

    function refreshCartMode() {
      return getCart().then(function (cart) {
        state.hasStack = (cart.items || []).some(function (item) {
          return isStackLine(item) || isMiniLine(item);
        });
        render();
      }).catch(function () {});
    }

    async function syncBuilderCart(subscriptionItems, miniItems, note, attributes) {
      var cart = await getCart();
      var stackLines = (cart.items || []).filter(isStackLine);
      var miniLines = (cart.items || []).filter(isMiniLine);
      var usedStack = {};
      var usedMini = {};
      var toAdd = [];
      var index;

      for (index = 0; index < subscriptionItems.length; index += 1) {
        var item = subscriptionItems[index];
        var line = takeLine(stackLines, item.id, usedStack);
        if (!line) {
          toAdd.push(item);
          continue;
        }
        if (line.quantity !== item.quantity || linePlanId(line) !== Number(item.selling_plan)) {
          await postCart('cart/change.js', {
            id: line.key,
            quantity: item.quantity,
            selling_plan: Number(item.selling_plan)
          });
        }
      }

      for (index = 0; index < miniItems.length; index += 1) {
        var mini = miniItems[index];
        var miniLine = takeLine(miniLines, mini.id, usedMini);
        if (!miniLine) {
          toAdd.push(mini);
          continue;
        }
        if (miniLine.quantity !== mini.quantity) {
          await postCart('cart/change.js', {
            id: miniLine.key,
            quantity: mini.quantity
          });
        }
      }

      var updates = {};
      stackLines.forEach(function (stackLine) {
        if (!usedStack[stackLine.key]) updates[stackLine.key] = 0;
      });
      miniLines.forEach(function (giftLine) {
        if (!usedMini[giftLine.key]) updates[giftLine.key] = 0;
      });
      if (Object.keys(updates).length) await postCart('cart/update.js', { updates: updates });
      if (toAdd.length) await postCart('cart/add.js', { items: toAdd });
      await postCart('cart/update.js', { note: note, attributes: attributes });
    }

    async function postCart(path, body) {
      var response = await fetch(shopifyRoot() + path, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(body || {})
      });
      var payload = null;
      try {
        payload = await response.json();
      } catch (error) {
        payload = null;
      }
      if (!response.ok) {
        var message = (payload && (payload.description || payload.message)) || 'Could not update the cart.';
        throw new Error(message);
      }
      return payload;
    }

    async function startCheckout() {
      if (state.busy || !selectedProducts().length) return;
      state.busy = true;
      state.error = '';
      render();
      try {
        await Promise.all(selectedProducts().map(ensurePlans));
      } catch (error) {
        state.busy = false;
        state.error = 'Could not load the subscription plan for a product.';
        render();
        return;
      }
      state.busy = false;
      render();
      var cents = subtotal();
      if (!canCheckout(cents)) return;
      state.busy = true;
      render();

      var subscriptionItems = [];
      selectedProducts().forEach(function (product) {
        var plan = planForDays(product.plans, state.days);
        subscriptionItems.push({
          id: product.variantId,
          quantity: state.qty[product.handle],
          selling_plan: plan.id,
          properties: {
            _bf_stack: 'Black Friday 2026'
          }
        });
      });

      /* PAUSED Oct 2026 — gift tiers and free minis are not part of this offer.
         Restore this block to add chosen minis and write the gift-card note again.
         The tier settings and mini list are still in data-bf26-config.
      var slots = slotsFor(cents);
      var miniItems = [];
      var miniNames = [];
      if (slots > 0) {
        minis.forEach(function (mini) {
          var qty = state.minis[mini.handle] || 0;
          if (!qty) return;
          miniItems.push({
            id: mini.variantId,
            quantity: qty,
            properties: {
              Gift: 'Black Friday mini'
            }
          });
          miniNames.push(mini.title + ' x' + qty);
        });
      }

      var tier = currentTier(cents);
      var note = [
        'Black Friday 2026 stack.',
        'Delivery every ' + state.days + ' days.',
        '25% off every order while the subscription stays active.',
        tier
          ? 'Gift card to add manually on the next renewal: ' + moneyText(config, tier.card) + '.'
          : 'Below the gift tier. No gift card.',
        miniNames.length ? 'Minis with this order: ' + miniNames.join(', ') + '.' : 'No minis.'
      ].join(' ');

      var attributes = {
        'BF2026 campaign': 'Black Friday 2026',
        'BF2026 delivery': 'Every ' + state.days + ' days',
        'BF2026 tier': tier ? moneyText(config, tier.spend) + '+' : 'Below gift tier',
        'BF2026 gift card on next renewal': tier ? moneyText(config, tier.card) : 'None',
        'BF2026 minis': miniNames.join(', ') || 'None'
      };
      */
      var miniItems = [];
      var note = [
        'Black Friday 2026 stack.',
        'Delivery every ' + state.days + ' days.',
        '25% off every order while the subscription stays active.'
      ].join(' ');
      var attributes = {
        'BF2026 campaign': 'Black Friday 2026',
        'BF2026 delivery': 'Every ' + state.days + ' days'
      };

      try {
        setLoaderStep('cart');
        if (state.hasStack) {
          await syncBuilderCart(subscriptionItems, miniItems, note, attributes);
        } else {
          await postCart('cart/clear.js', {});
          await postCart('cart/add.js', { items: subscriptionItems.concat(miniItems) });
          await postCart('cart/update.js', { note: note, attributes: attributes });
        }
        setLoaderStep('discount');
        await wait(3000);
        setLoaderStep('checkout');
        await wait(600);
        window.location.href = shopifyRoot() + 'checkout';
      } catch (error) {
        hideLoader();
        state.busy = false;
        state.error = error.message || (state.hasStack ? 'Could not update the cart.' : 'Could not start checkout.');
        render();
      }
    }

    function wait(ms) {
      return new Promise(function (resolve) {
        window.setTimeout(resolve, ms);
      });
    }

    function setLoaderStep(name) {
      var messages = {
        cart: 'Processing your cart',
        discount: 'Applying Discounts',
        checkout: 'Redirecting to checkout'
      };
      var loader = root.querySelector('[data-bf-loader]');
      var message = loader && loader.querySelector('[data-bf-loader-message]');
      if (!loader || !message) return;
      closeMiniModal();
      loader.hidden = false;
      document.documentElement.classList.add('bf26-loader-open');
      window.requestAnimationFrame(function () {
        loader.classList.add('is-in');
      });
      message.classList.remove('is-in');
      window.setTimeout(function () {
        message.textContent = messages[name] || messages.cart;
        message.classList.add('is-in');
      }, 160);
    }

    function hideLoader() {
      var loader = root.querySelector('[data-bf-loader]');
      if (loader) {
        loader.classList.remove('is-in');
        loader.hidden = true;
      }
      document.documentElement.classList.remove('bf26-loader-open');
    }

    var minusIcon = '<svg width="10" height="2" viewBox="0 0 10 2" aria-hidden="true"><path d="M0 0H10V2H0V0Z" fill="currentColor"></path></svg>';
    var plusIcon = '<svg width="10" height="10" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M6 0V12"></path><path d="M0 6L12 6"></path></svg>';

    function productByHandle(handle) {
      var found = null;
      products.some(function (product) {
        if (product.handle === handle) {
          found = product;
          return true;
        }
        return false;
      });
      return found;
    }

    function rememberProduct(product) {
      if (!productByHandle(product.handle)) {
        var qty = parseInt(savedQty[product.handle], 10);
        if (product.available && qty > 0) state.qty[product.handle] = Math.min(qty, MAX_QTY);
        products.push(product);
      }
    }

    function tagList(tags) {
      if (!tags) return [];
      if (Array.isArray(tags)) return tags;
      return String(tags).split(',');
    }

    function supplyLine(tags) {
      var count = '';
      var capsules = false;
      tagList(tags).forEach(function (tag) {
        var text = String(tag).trim();
        var match = text.match(/^(\d+)\s*x$/i);
        if (match) count = match[1];
        if (text.toLowerCase() === 'capsules') capsules = true;
      });
      if (!count || !capsules) return '';
      return count + ' capsules | 30-day supply';
    }

    function applyPack(product, tags) {
      if (product && !product.pack) {
        var line = supplyLine(tags);
        if (line) product.pack = line;
      }
      return product;
    }

    function buildCard(product) {
      var card = document.createElement('article');
      card.className = 'bf26-card';
      card.setAttribute('data-bf-card', '');
      card.setAttribute('data-handle', product.handle);

      var media = document.createElement('div');
      media.className = 'bf26-card__media';
      if (product.image) {
        var image = document.createElement('img');
        image.src = product.image;
        image.alt = product.title;
        image.loading = 'lazy';
        media.appendChild(image);
      }
      card.appendChild(media);

      var head = document.createElement('div');
      head.className = 'bf26-card__head';
      head.appendChild(textNode('h3', 'bf26-card__title h6', product.title));
      var benefit = textNode('p', 'bf26-card__benefit', product.benefit || '');
      if (!product.benefit) benefit.hidden = true;
      head.appendChild(benefit);
      card.appendChild(head);

      var pack = textNode('p', 'bf26-card__pack', product.pack || '');
      if (!product.pack) pack.hidden = true;
      card.appendChild(pack);

      var price = document.createElement('p');
      price.className = 'bf26-card__price';
      price.setAttribute('data-bf-price', '');
      fillPrice(price, product.price, payable(product.price));
      card.appendChild(price);

      var actions = document.createElement('div');
      actions.className = 'bf26-card__actions';
      if (product.available) {
        var stepper = document.createElement('div');
        stepper.className = 'bf26-qty';
        stepper.setAttribute('data-bf-stepper', '');
        var dec = document.createElement('button');
        dec.type = 'button';
        dec.className = 'bf26-qty__btn';
        dec.setAttribute('data-bf-dec', '');
        dec.setAttribute('aria-label', 'Decrease ' + product.title);
        dec.innerHTML = minusIcon;
        var value = document.createElement('span');
        value.className = 'bf26-qty__value';
        value.setAttribute('data-bf-qty', '');
        value.textContent = '1';
        var inc = document.createElement('button');
        inc.type = 'button';
        inc.className = 'bf26-qty__btn';
        inc.setAttribute('data-bf-inc', '');
        inc.setAttribute('aria-label', 'Increase ' + product.title);
        inc.innerHTML = plusIcon;
        stepper.appendChild(dec);
        stepper.appendChild(value);
        stepper.appendChild(inc);
        var add = document.createElement('button');
        add.type = 'button';
        add.className = 'bf26-add';
        add.setAttribute('data-bf-add', '');
        add.setAttribute('data-bf-add-one', '');
        add.textContent = 'Add to my subscription';
        actions.appendChild(stepper);
        actions.appendChild(add);
      } else {
        actions.appendChild(textNode('p', 'bf26-card__sold', 'Sold out'));
      }
      card.appendChild(actions);

      var warn = textNode('p', 'bf26-card__warn', '');
      warn.setAttribute('data-bf-warn', '');
      warn.hidden = true;
      card.appendChild(warn);
      return card;
    }

    function filteredCatalog() {
      if (!searchQuery) return catalog;
      return catalog.filter(function (product) {
        var haystack = (product.title + ' ' + (product.benefit || '') + ' ' + product.handle).toLowerCase();
        return haystack.indexOf(searchQuery) !== -1;
      });
    }

    function syncGrid() {
      var grid = root.querySelector('[data-bf-grid]');
      if (!grid || !catalog.length) return;
      var matches = filteredCatalog();
      var shown = searchQuery ? matches : matches.slice(0, visibleCount);
      var shownHandles = {};
      shown.forEach(function (product) {
        rememberProduct(product);
        shownHandles[product.handle] = true;
        var card = cards[product.handle];
        if (!card) {
          card = buildCard(product);
          cards[product.handle] = card;
        }
        grid.appendChild(card);
        card.hidden = false;
      });
      Object.keys(cards).forEach(function (handle) {
        if (!shownHandles[handle]) cards[handle].hidden = true;
      });
      var more = root.querySelector('[data-bf-more]');
      if (more) {
        more.hidden = !!searchQuery || visibleCount >= matches.length;
        more.textContent = more.hidden ? '' : 'Loading products…';
      }
      var none = root.querySelector('[data-bf-none]');
      if (none) none.hidden = !searchQuery || matches.length > 0;
      var waiting = root.querySelector('[data-bf-waiting]');
      if (waiting) waiting.hidden = true;
      render();
    }

    function absorbRawProduct(raw) {
      var variant = (raw.variants && raw.variants[0]) || null;
      if (!variant) return null;
      var existing = productByHandle(raw.handle);
      if (existing) {
        if (!existing.image && raw.images && raw.images[0]) existing.image = raw.images[0].src;
        return applyPack(existing, raw.tags);
      }
      return applyPack({
        handle: raw.handle,
        title: raw.title,
        benefit: '',
        pack: variant.title && variant.title !== 'Default Title' ? variant.title : '',
        variantId: variant.id,
        price: Math.round(parseFloat(variant.price) * 100) || 0,
        available: variant.available !== false,
        image: (raw.images && raw.images[0] && raw.images[0].src) || '',
        plans: [],
        plansLoaded: false
      }, raw.tags);
    }

    function absorbJsProduct(data) {
      var variant = data && data.variants && data.variants[0];
      if (!data || !data.handle || !variant) return null;
      var existing = productByHandle(data.handle);
      if (existing) {
        if (!existing.image && data.featured_image) existing.image = data.featured_image;
        return applyPack(existing, data.tags);
      }
      return applyPack({
        handle: data.handle,
        title: data.title,
        benefit: '',
        pack: variant.title && variant.title !== 'Default Title' ? variant.title : '',
        variantId: variant.id,
        price: variant.price,
        available: variant.available !== false,
        image: data.featured_image || '',
        plans: [],
        plansLoaded: false
      }, data.tags);
    }

    function loadCatalog() {
      var collectionHandle = config.catalog || 'all';
      var ordered = [];
      var seen = {};
      var map = {};
      var filling = {};
      var jsonReady = collectJson(1);

      function readHandles(html) {
        var added = 0;
        var pattern = /<product-card[^>]*\shandle="([^"]+)"/g;
        var match;
        while ((match = pattern.exec(html))) {
          if (seen[match[1]]) continue;
          seen[match[1]] = true;
          ordered.push(match[1]);
          added += 1;
        }
        return added;
      }

      function applyOrder() {
        catalog = ordered.map(function (itemHandle) { return map[itemHandle]; }).filter(Boolean);
        if (catalog.length) syncGrid();
      }

      function fillMissing() {
        ordered.forEach(function (itemHandle) {
          if (map[itemHandle] || filling[itemHandle]) return;
          filling[itemHandle] = true;
          fetch(shopifyRoot() + 'products/' + itemHandle + '.js', {
            headers: { Accept: 'application/json' }
          })
            .then(function (response) { return response.json(); })
            .then(function (data) {
              var product = absorbJsProduct(data);
              if (product) map[product.handle] = product;
              applyOrder();
            })
            .catch(function () {});
        });
      }

      function collectJson(page) {
        return fetch(shopifyRoot() + 'collections/' + collectionHandle + '/products.json?limit=250&page=' + page, {
          headers: { Accept: 'application/json' }
        })
          .then(function (response) { return response.json(); })
          .then(function (data) {
            var batch = data.products || [];
            batch.forEach(function (raw) {
              var product = absorbRawProduct(raw);
              if (product) map[product.handle] = product;
            });
            if (batch.length === 250) return collectJson(page + 1);
            return map;
          });
      }

      function pageUrl(page, sectionId) {
        var url = shopifyRoot() + 'collections/' + collectionHandle + '?page=' + page;
        if (sectionId) url += '&section_id=' + encodeURIComponent(sectionId);
        return url;
      }

      function loadRest(page, sectionId) {
        if (page > 20) return Promise.resolve();
        return fetch(pageUrl(page, sectionId), { headers: { Accept: 'text/html' } })
          .then(function (response) { return response.text(); })
          .then(function (html) {
            if (!readHandles(html)) return null;
            return jsonReady.then(function () {
              applyOrder();
              fillMissing();
              return loadRest(page + 1, sectionId);
            });
          })
          .catch(function () {});
      }

      function showFailure() {
        if (catalog.length) return;
        var more = root.querySelector('[data-bf-more]');
        if (more) more.textContent = 'Could not load the collection.';
      }

      return fetch(pageUrl(1, ''), { headers: { Accept: 'text/html' } })
        .then(function (response) { return response.text(); })
        .then(function (html) {
          var sectionMatch = html.match(/id="shopify-section-(template--[^"]+__main)"/);
          var sectionId = sectionMatch ? sectionMatch[1] : '';
          if (!readHandles(html)) throw new Error('empty');
          return jsonReady.then(function () {
            applyOrder();
            fillMissing();
            return loadRest(2, sectionId);
          });
        })
        .catch(showFailure);
    }

    var searchInput = root.querySelector('[data-bf-search]');
    if (searchInput) {
      var searchTimer = null;
      searchInput.addEventListener('input', function () {
        clearTimeout(searchTimer);
        var value = searchInput.value;
        searchTimer = setTimeout(function () {
          searchQuery = value.trim().toLowerCase();
          syncGrid();
        }, 200);
      });
    }

    var moreNode = root.querySelector('[data-bf-more]');
    if (moreNode && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting || searchQuery) return;
        if (visibleCount >= filteredCatalog().length) return;
        visibleCount += PAGE_SIZE;
        syncGrid();
      }, { rootMargin: '500px' }).observe(moreNode);
    }

    render();
    loadCatalog();
    refreshCartMode();
  }

  ready(function () {
    document.querySelectorAll('[data-bf26-root]').forEach(init);
  });
})();
